import { Injectable } from '@angular/core';
import { BackendDataService } from '../services/backendDataService/backendDataService';
import { UserModel } from './UserModel';
import { ArticleModel } from './ModelsModel';
import { Cluster } from './ProposalModel';


export const WizardStatus={
    BOZZA:"B",
    SALVATO:'S',
    INVIATO:'I'
}
@Injectable()
export class WizardModel{
    [x: string]: any;
    isMarketSelection: any;
    async getLastClusters(): Promise<Cluster[]> {
      throw new Error("Method not implemented.");
    }
    async removeClusters(missingClusters: Array<Cluster>):Promise<any> {
      throw new Error("Method not implemented.");
    }
    wasDuplicated: boolean;
    clusters:Array<Cluster>;
    getModelsCount(filters: any):Promise<number> {
      throw new Error("Method not implemented.");
    }
    async getArticlesFromStyleName(styleName):Promise<ArticleModel[]> {
      throw new Error("Method not implemented.");
    }
    async getModels(filter: any):Promise<any> {
      throw new Error("Method not implemented.");
    }
    removeSearch(filter: any) {
      throw new Error("Method not implemented.");
    }
    duplicate(): any {
      throw new Error("Method not implemented.");
    }
    createProposal(): any {
      throw new Error("Method not implemented.");
    }
    isDuplicated: any;
    isCreateProposal: any;
    removeBrands(missingBrands: any[]) {
      throw new Error("Method not implemented.");
    }
    send(params: any) {
      throw new Error("Method not implemented.");
    }
    removeModel(model: any) {
      throw new Error("Method not implemented.");
    }
    salesOrg: any;
    getArticles(filter: any): any {
      throw new Error("Method not implemented.");
    }
    getWizardClient() {
      throw new Error("Method not implemented.");
    }
    id:string;
    
    details=[];
    name:string;
    code:string;
    customerName:string;
    articleCount:number;
    images:Array<string>;
    modelCount:number;
    opticalFramesCount:number;
    idClient:string;
    country:string;
    creationDate:string;
    distrCh:string;
    status:string;
    sunglassesCount:number;
    totalWHS:string;
    brands:Array<any>=[];
    username:string;
    customerClass:string;
    colorFromBarcode:string;
    notToAddArticle: boolean;

    constructor(public backend: BackendDataService, public userModel: UserModel){

    };
    init(obj:any={}) {
        Object.assign(this, obj);

    }
    load(){
        
    }
    isSellable( article  ){
      return true;
    }
    count(filter){
       
    }
    async save(){
        
    }

    getDetails(filter:any)
    {

        
    }
    getDetailCount(filter:any)
    {
      
    }

    addModel(model:any):any{

    }

    addArticle(article:any, model?:any){
      
    }

    removeArticle(article: any, model?: any) {
      
    }

    addSearch(filter:any){

    }
    

    getList(filter:any){

        
    }
}